/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"inputWrapper":"inputWrapper_ygptt"};